import { render, staticRenderFns } from "./BrowerTitle.vue?vue&type=template&id=7e154c6c&"
import script from "./BrowerTitle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BrowerTitle.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports